export function formToArray(form: HTMLFormElement) {
  return Array.from(new FormData(form)).map(([name, value]) => ({
    name,
    value: value as string,
  }));
}

export function formToObject(form: HTMLFormElement) {
  return Object.fromEntries(new FormData(form).entries());
}

export function extractContent(html: string) {
  return new DOMParser().parseFromString(html, 'text/html').documentElement.textContent;
}

export function disableIf(element: HTMLElement, condition: boolean) {
  element.classList[condition ? 'add' : 'remove']('disabled');
}

export default { formToArray, formToObject, extractContent, disableIf };
